import { createSelector } from '@reduxjs/toolkit';

import {
  PAYMENT_METHOD_FEATURE_KEY,
  PaymentMethodState,
} from './paymentMethod.slice';

export const getPaymentMethodState = (rootState: any): PaymentMethodState =>
  rootState[PAYMENT_METHOD_FEATURE_KEY];

export const selectPaymentMethod = createSelector(
  getPaymentMethodState,
  (s) => s.paymentMethod,
);

export const selectUserCountry = createSelector(
  getPaymentMethodState,
  (s) => s.country,
);

export const selectPaymentIqMerchantId = createSelector(
  getPaymentMethodState,
  (s) => s.paymentIqMerchantId,
);

export const selectTaxConfiguration = createSelector(
  getPaymentMethodState,
  (method) => method.tax?.GHA || null,
);

export const selectRegistrationRequired = createSelector(
  getPaymentMethodState,
  (s) => s.registrationRequired,
);

export const selectAppliedBonus = createSelector(
  getPaymentMethodState,
  (method) => method.bonus,
);

export const selectAccounts = createSelector(
  getPaymentMethodState,
  (method) => method.accounts,
);
